import axios from "axios";
import { Sign, ClientInfo, headData, perfectData } from "./perfectData";
import { trimParams } from "@/util/base";
import { RequestRecovery } from "xhwebtool";
window.Promise = Promise;

axios.defaults.timeout = 5000;
axios.defaults.withCredentials = true;
// 请求拦截器
axios.interceptors.request.use(
  async (config) => {
    config.url = RequestRecovery.replaceUrl2RetryApi(config.url);

    const headDatas = await headData(config.url);

    // 获取服务器时间接口不携带headers信息
    if (config.url.indexOf("/apiv1/common/server-time") == -1) {
      // 写入头部
      config.headers["Client-Info"] = ClientInfo(headDatas);
      config.headers["Sign"] = Sign(headDatas);
      config.headers["Client-Lang"] = "ja-jp";
    }

    // 组装完整版本的请求参数，统一处理ts
    if (
      config.url.indexOf("/apiv1/common/server-time") !== -1 ||
      config.url.indexOf("/apiv1/common/init") !== -1 ||
      config.url.indexOf("/apiv1/comm/hybrid/country-info") !== -1
    ) {
      config.data = perfectData({ ...config.data, ts: headDatas.ts }, 1);
    } else {
      config.data = perfectData({ ...config.data, ts: headDatas.ts });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  async (response) => {
    // 在这里可以对响应做一些处理，比如根据返回码进行统一处理等
    const res = await RequestRecovery.fetch(response, axios);
    if (res.status === 200) {
      return res;
    } else {
      return Promise.reject(res);
    }
  },
  async (error) => {
    // 响应错误时做些事情
    const err = await RequestRecovery.fetch(error, axios);
    return Promise.reject(err);
  }
);

// 封装 post 请求
export const postFetch = async (url, params = {}, config = {}) => {
  // 去除 params 对象中所有字符串值的前后空格
  const trimmedParams = trimParams(params);

  const res = await axios.post(url, trimmedParams, {
    ...config,
    recoveryType: 4,
  });
  const responseData =
    typeof res.data === "string" ? JSON.parse(res.data) : res.data;

  if (res.status === 200) {
    if (
      url.includes("/apiv1/comm/server-time") ||
      url.includes("/apiv1/comm/init")
    ) {
      if (responseData.code === 200) {
        return responseData;
      } else {
        throw {
          code: responseData.code || -100,
          msg: responseData.msg || "服务器开小差了。",
          requestOption: { url, trimmedParams },
        };
      }
    } else {
      return responseData;
    }
  } else {
    throw {
      code: responseData.code || -100,
      msg: responseData.msg || "服务器开小差了。",
      requestOption: { url, trimmedParams },
    };
  }
};
